<template>
  <div class="dash-item dash-poll col-md-4" id="poll">
    <div class="box-header dash-bg-color-skin-light-10">
      <div class="col-xs-2 header-left">
        <div class="rec"></div>
      </div>
      <div class="col-xs-8 header-center">
        {{ app.home[app.nowLang].poll }}
      </div>
      <div class="col-xs-2 pull-right align-right add-poll-pc cursor-pointer">  
          <i class="fa fa-refresh cursor-pointer" aria-hidden="true" @click="refresh()"></i>   
      </div>
      <!-- <div class="col-xs-2 pull-right align-right add-poll-pc cursor-pointer">
        <i class="fa fa-plus-circle " aria-hidden="true" @click="togglePoll()" v-show="pollIndexDisp"></i>
      </div> -->
    </div>
    <poll-index v-show="pollIndexDisp"
                :polls="polls"
                :pollAddChoice="labels[app.nowLang].pollAddChoice"
                :pollHistory="labels[app.nowLang].pollHistory"
                :collapsed="collapsed"
                :progressPercent="progressPercent"
                :nowLang="app.nowLang"
                :triggerPollInfiniteBool="triggerPollInfiniteBool"
                :receivedPollsInfiniteLoading="receivedPollsInfiniteLoading"
                :oldPolls="oldPolls"
                :receivedOldPollsInfiniteLoading="receivedOldPollsInfiniteLoading"
                :postChoice="postChoice"
                :postSelectChoice="postSelectChoice"
                :triggerResetBool="triggerResetBool" 
                @disableTriggerResetBool="triggerResetBool = false" 
                :filePath="pathImage" />
    <!-- <poll-add v-show="addPollDisp" :togglePoll="togglePoll" :polls="polls" :nowLang="app.nowLang" :postPoll="postPoll" /> -->
  </div>
</template>

<script>
import pollIndex from 'components/poll/index'
import pollAdd from 'components/poll/addpoll'
import * as types from 'store/modules/poll/mutation-types'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'poll',
  data () {
    return {
      app: this.$parent.$parent.$parent.$parent,
      dash: this.$root.$children[0].$children[0],
      collapsed: true,
      pollIndexDisp: true,
      addPollDisp: false,
      triggerResetBool: false,
      labels: {
        en: {
          pollAddChoice: 'Add more choice',
          pollHistory: 'View old poll'
        },
        th: {
          pollAddChoice: 'เพิ่มตัวเลือก',
          pollHistory: 'ดูแบบสอบถามที่ผ่านมา'
        }
      }
    }
  },
  props: [ 'pcDisp', 'triggerPollInfiniteBool' ],
  computed: {
    ...mapGetters({
      polls: types.GET_POLLS,
      oldPolls: types.GET_OLD_POLLS,
      pathImage: types.GET_PATH_IMAGE
    })
  },
  created () {
    this.receivedPathImage()
  },
  methods: {
    progressPercent (curVote, totalVote) {
      if (totalVote > 0) {
        return (100 * curVote / totalVote) + '%'
      } else {
        return '0%'
      }
    },
    refresh () {
      this.triggerResetBool = true
    },
    ...mapActions({
      receivedPollsInfiniteLoading: types.RECEIVED_POLLS_INFINITE_LOADING,
      receivedOldPollsInfiniteLoading: types.RECEIVED_OLD_POLLS_INFINITE_LOADING,
      postPoll: types.POST_POLL,
      postChoice: types.POST_CHOICE,
      postSelectChoice: types.POST_SELECT_CHOICE,
      deleteChoice: types.DELETE_CHOICE,
      receivedPathImage: types.RECEIVED_PATH_IMAGE
    }),
    togglePoll () {
      this.addPollDisp = !this.addPollDisp
      this.pollIndexDisp = !this.pollIndexDisp
    }
  },
  components: {
    pollIndex,
    pollAdd
  }
}
</script>

<style src="./style.scss" lang='scss'>

</style>



// WEBPACK FOOTER //
// component.vue?71ef3262